// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchEngine_section__3QR4m","sectionWithRange":"SearchEngine_sectionWithRange__12GlH","range":"SearchEngine_range__WvqVy"};